import script from "./StakingView.vue?vue&type=script&setup=true&lang=js"
export * from "./StakingView.vue?vue&type=script&setup=true&lang=js"

import "./StakingView.vue?vue&type=style&index=0&id=d2eaaeac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2eaaeac"]])

export default __exports__